export default __webpack_public_path__ + "static/media/photo12.62a2e493.jpg";